// extracted by mini-css-extract-plugin
export default {"root":"DepartmentMenu_root__f4mCM","container":"DepartmentMenu_container__dsdf6"};